export const addAnalyticsForEditBtn = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = {
    eventAction: "my account:account settings:edit",
    eventName: "my account:account settings:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "my-account:account-settings",
    internalLinkType: "my account:login & security",
    internalLinkZoneName: "my account:account settings",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}
